import { render, staticRenderFns } from "./TestingChangeSettings.vue?vue&type=template&id=0139ad1c"
import script from "./TestingChangeSettings.vue?vue&type=script&lang=ts"
export * from "./TestingChangeSettings.vue?vue&type=script&lang=ts"
import style0 from "./TestingChangeSettings.vue?vue&type=style&index=0&id=0139ad1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports